import React, { Dispatch, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';
import { IconQr } from '../../../../../../assets/icons/icon-qr';

type QrButtonProps = {
  setQrPageOpen: Dispatch<SetStateAction<boolean>>;
};

export const QrButton: React.FC<QrButtonProps> = ({ setQrPageOpen }) => {
  const { t } = useTranslation('installation');

  const handleClick = () => setQrPageOpen(true);

  return (
    <button className="button button--secondary" onClick={handleClick}>
      <IconQr />
      {t('exalus.scanQr')}
    </button>
  );
};
